import { Component, EventEmitter, OnInit, Output, input, inject, computed, signal, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Layer } from 'ol/layer';
import { PaddockDexie } from 'src/app/models/paddock.model';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderDragEvent, MatSliderModule } from '@angular/material/slider';
import VectorLayer from 'ol/layer/Vector';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { switchMap, of, map, distinctUntilChanged, filter } from 'rxjs';
import { ClippedLayerService } from 'src/app/services/BaseLayerServices/clippedLayer.service';
import { PropertyService } from 'src/app/services/property.service';
import { layerOpacity$, layerVisibility$ } from 'src/app/_helpers/rxjs_ol';
import { FormsModule } from '@angular/forms';
import { SelectComponent, SwitchComponent, AccordionComponent, AccordionItemComponent, SliderComponent } from '@aetherion/ui';

@Component({
    selector: 'app-topex-layer',
    templateUrl: './topex-layer.component.html',
    styleUrls: ['./topex-layer.component.css'],
    standalone: true,
    imports: [
    CommonModule,
    FormsModule,
    SelectComponent,
    SwitchComponent,
    AccordionComponent,
    AccordionItemComponent,
    SliderComponent
    ]
})
export class TopexLayerComponent implements OnInit {

    private readonly clippedLayerService = inject(ClippedLayerService);
    private readonly propertyService = inject(PropertyService);

  readonly layer = input<VectorLayer<any>>(undefined);
  readonly paddockSelect = input<boolean>(false);
  readonly paddocks = input<PaddockDexie[]>([]);

  @Output() downloadLayers = new EventEmitter<boolean>();
  @Output() showPaddocks = new EventEmitter<PaddockDexie[]>();

   selectedPaddocks = signal([]);

  activeProperty = toSignal(
    this.propertyService.activeProperty.pipe(
      map((val) => (val == null ? false : true))
    ),
    { initialValue: false }
  );

  isDownloaded = toSignal(
    this.propertyService.activeProperty.pipe(
      switchMap((property) =>
        property
          ? this.clippedLayerService.getClippedLayers_Property(
              property.propertyID
            )
          : of([])
      ),
      map((layers) =>
        layers.some((l) => l.layerName.toLowerCase() === 'topex')
      ),
      distinctUntilChanged()
    ),
    { initialValue: false }
  );

  baseLayer$ = toObservable(this.layer).pipe(
    filter((g): g is VectorLayer<any> => g !== null)
  );

  opacity$ = this.baseLayer$.pipe(switchMap((g) => layerOpacity$(g)));

  visibility$ = this.baseLayer$.pipe(switchMap((g) => layerVisibility$(g)));

  // OL has opacity as a scale from 0 - 1, I.E 0.1 0.2 etc, we are mapping it to be easier to display percentages
  opacity = toSignal(this.opacity$.pipe(map((opacity) => opacity * 100)), {
    initialValue: 100
  });

  visible = toSignal(this.visibility$, { initialValue: true });

  opacityLabel = computed(() => {
    const opacity = this.opacity() as Number;

    return `${opacity.toFixed(2)}%`;
  });

  title = computed(() =>
    this.layer() == null ? 'Unknown' : this.layer().get('title')
  );


  constructor() {


    effect(() => {
      const selectedPaddocks = this.selectedPaddocks();

      if(selectedPaddocks == null)
      {
        return;
      }

      this.showPaddocks.emit(selectedPaddocks)

    })
  }

  ngOnInit(): void {
  }

  onDownloadLayers(): void {
    this.downloadLayers.emit(true);
  }


  setLayerGroupOpacity(opacity): void {
    this.layer().setOpacity(opacity / 100);
  }



  setLayerGroupVisibility(event): void {
    this.layer().setVisible(event);
  }


}
